
import { defineStore } from "pinia";
import { Local } from '@/utils/storage'
export const useSystemStore = defineStore("system", {
    state: () => {
        return {
            admin_name: Local.get("userInfo")?.realName || '管理员',
            current_mechanism: Local.get("current_mechanism") || {},
            mechanism_list: Local.get("mechanism_list") || [],
            categories_list: [],
            area_list: [],
            permissionCodes: Local.get('permissionCodes') || []
        }
    },
    actions: {
        getPermissions() {
            

        }
    }
})